import { observer } from 'mobx-react-lite'
import { FC, useContext, useEffect, useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { useLocation, useNavigate } from 'react-router-dom'
import { Context } from '..'
import useWindowDimensions from '../core/hooks/useWindowDimensions'
import { LOCALES } from '../core/i18n/locales'
import { StorageKeys } from '../core/utils/defaults'
import { isElementInViewport, prevent, stripPhone } from '../core/utils/utils'

import styles from '../styles/Footer.module.scss'

const Footer: FC = () => {
	const { store, adminStore } = useContext(Context)

	const location = useLocation()
	const navigate = useNavigate()
	const { width } = useWindowDimensions()

	const [isVisible, setIsVisible] = useState(false)
	const [footerVisible, setFooterVisible] = useState(false)
	const [isToTopVisible, setIsToTopVisible] = useState(false)

	const toTop = () => {
		window.scrollTo({
			behavior: 'smooth',
			top: 0,
		})
	}

	const navTo = (event: any) => {
		event.preventDefault()
		event.stopPropagation()

		let path = '',
			nodeName = event.target.nodeName.toLowerCase()

		if (nodeName == 'img' || nodeName == 'span') {
			path = event.target.parentElement.pathname
		} else {
			path = event.target.pathname
		}

		if (path == location.pathname) {
			return
		}

		store.setIsFaderVisible(true)
		setTimeout(() => {
			store.setIsFaderShown(true)

			setTimeout(() => {
				navigate(path)
			}, 300)
		}, 100)
	}

	const setLocale = (val: string) => {
		store.setLocale(val)
		localStorage.setItem(StorageKeys.LOCALE, val)
	}

	useEffect(() => {
		const onScroll = (event: any) => {
			const scrollTop = event.target.scrollTop
			if (scrollTop >= 80) {
				setIsToTopVisible(true)
			} else {
				setIsToTopVisible(false)
			}

			// if (width > 768) {
			const ftr = document.getElementById('ftr')
			if (ftr != null && isElementInViewport(ftr)) {
				setFooterVisible((prev) => (prev = true))
			}
			// }
		}

		// if (width > 768) {
		setTimeout(() => {
			setIsVisible((prev) => (prev = true))
			onScroll({ target: { scrollTop: 0 } })
		}, 400)
		// } else {
		//   setIsVisible(prev => prev = true)
		//   setFooterVisible(prev => prev = true)
		// }

		document.getElementById('root')!.addEventListener('scroll', onScroll)

		return () => {
			document.getElementById('root')!.removeEventListener('scroll', onScroll)
		}
	}, [])

	return (
		<>
			<div className={styles.footer} id='footer'>
				<div className='container'>
					<div className='row'>
						<div className='col-12'>
							<div className={styles.footer_wrap}>
								<div className={styles.fw_top}>
									<div className={styles.fw_top_logo}>
										<a className={styles.alogo} href='/'>
											<FormattedMessage id='studios_srch_caps' />
										</a>

										<div className={styles.contacts}>
											<a href='mailto:info@podcastbery.ru' target='_blank'>
												info@podcastbery.ru
											</a>
											<a className={styles.phone_button} href='tel:88001015424'>
												<i className='fa-solid fa-phone'></i> 8 (800) 101-54-24
											</a>
										</div>

										<div className={styles.socials}>
											<a href='https://vk.com/podcastbery' rel='nofollow' target='_blank'>
												<i className='fab fa-vk'></i>
											</a>
											<a href='https://t.me/podcastberyy' rel='nofollow' target='_blank'>
												<i className='fab fa-telegram'></i>
											</a>
											{/* <a href="#" target="_blank"><i className="fab fa-whatsapp"></i></a> */}
										</div>
									</div>
									<div className={styles.fw_top_menus}>
										<div className={styles.fw_top_menu}>
											<h4>
												<FormattedMessage id='footer_clients' />
											</h4>
											<a href='/'>
												<FormattedMessage id='head_studios' />
											</a>
											<a href='/about'>
												<FormattedMessage id='head_about' />
											</a>
											<a href='/podcasts'>
												<FormattedMessage id='footer_c_podcasts' />
											</a>
											<a href='/blog'>
												<FormattedMessage id='footer_c_blog' />
											</a>
											<a href='/user_agreement'>
												<FormattedMessage id='footer_c_agree' />
											</a>
											<a href='/otzyvy'>{store.locale == LOCALES.RUSSIAN ? 'Отзывы' : 'Reviews'}</a>
										</div>
										<div className={styles.fw_top_menu}>
											<h4>
												<FormattedMessage id='footer_studios' />
											</h4>
											<a href='/connect'>
												<FormattedMessage id='footer_s_partner' />
											</a>
											<a href='/partner'>
												<FormattedMessage id='footer_s_cabinet' />
											</a>
											<a href='/acceptance'>
												<FormattedMessage id='footer_s_agree' />
											</a>
											<a href='/rules'>
												<FormattedMessage id='footer_s_rules' />
											</a>
										</div>
									</div>
								</div>
								<div className={styles.fw_bottom}>
									<div className={styles.fw_bottom__copys}>
										<FormattedMessage id='footer_copys' />
										<br />
										<small>
											{store.locale == LOCALES.RUSSIAN
												? 'ИП Казанцев Владислав Дмитриевич (ИНН 245210737200, ОГРНИП 318246800016960)'
												: 'IP Kazantsev Vladislav Dmitrievich (TIN 245210737200, OGRIP 318246800016960)'}
										</small>
									</div>
									<div className={styles.fw_bottom__links}>
										<a
											href='#'
											onClick={(ev) => {
												prevent(ev)
												setLocale(store.locale == 'ru-RU' ? 'en-EN' : 'ru-RU')
											}}
										>
											{store.locale == 'ru-RU' ? 'English' : 'Russian'}
										</a>
										<a href='/cities'>
											<FormattedMessage id='footer_cities' />
										</a>
										<a href='/policy'>
											<FormattedMessage id='footer_policy' />
										</a>
									</div>
								</div>
							</div>
						</div>
						{/* <div className="col-12 col-md-4">
              <div className={styles.logo}>
                <img src="/assets/images/logo.svg" />
              </div>
              <div className={styles.flexedd}>
                <div className={styles.copys}>
                  <p>© 2004-2024 «Фермерские истории»</p>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-8">
            </div>
            <div className="col-12">
              <div className={"row " + styles.flexed}>
                <div className={"col-12 col-md-12 " + styles.flx}>
                  <div className={styles.xlinks}>
                    <a href="https://fermstory.ru" target="_blank">Наш сайт</a>
                    <a href="/policy">Политика конфиденциальности</a>
                  </div>
                </div>
              </div>
            </div> */}
					</div>
				</div>
			</div>
		</>
	)
}

export default observer(Footer)
